import MainCover from './Main/MainCover';



function Home () {
    return(
        <div>
            
            <MainCover />
            
        </div>
       
    );
}

export default Home;